import { CanvasSkeleton } from "@/components/skeletons";
import { GrammarFormEditor } from "@/components/slides/editor/canvas/grammar/form/GrammarFormEditor";
import { GrammarResponseEditor } from "@/components/slides/editor/canvas/grammar/response/GrammarResponseEditor";
import { GrammarSentenceEditor } from "@/components/slides/editor/canvas/grammar/sentence/GrammarSentenceEditor";
import { HandWritingEditor } from "@/components/slides/editor/canvas/handWriting/HandWritingEditor";
import { FreeformCanvas } from "@/components/slides/editor/canvas/other/FreeFormCanvas";
import { OtherCanvasEditor } from "@/components/slides/editor/canvas/other/OtherCanvasEditor";
import { PhonicsDecodeEditor } from "@/components/slides/editor/canvas/phonics/decode/PhonicsDecodeEditor";
import { PhonicsEncodeEditor } from "@/components/slides/editor/canvas/phonics/encode/PhonicsEncodeEditor";
import { ReadingFluencyEditor } from "@/components/slides/editor/canvas/reading/fluency/ReadingFluencyEditor";
import { WordPronunciationEditor } from "@/components/slides/editor/canvas/word/pronunciation/WordPronunciationEditor";
import WordVocabularyEditor from "@/components/slides/editor/canvas/word/vocabulary/WordVocabularyEditor";
import { useAppSelector } from "@/store/hooks";
import type { SlideTemplate } from "@ai-teach/types";
import { resolveSlideTemplate } from "@ai-teach/types";
import type { JSX } from "react";

// Exhaustive by construction: a new SlideTemplate value fails to compile until it has an editor.
const EDITOR_BY_TEMPLATE: Record<SlideTemplate, () => JSX.Element> = {
  vocabulary: () => <WordPronunciationEditor />,
  listenRepeat: () => <WordVocabularyEditor />,
  // OtherCanvasEditor is FreeformCanvas plus the sub-quiz panel, which only OtherSlideData has.
  freeformCanvas: () => <OtherCanvasEditor />,
  wordCanvas: () => <FreeformCanvas />,
  conversation: () => <GrammarFormEditor />,
  videoQuestion: () => <GrammarResponseEditor />,
  audioRevealPrompt: () => <GrammarSentenceEditor />,
  passageReading: () => <ReadingFluencyEditor />,
  soundToSpelling: () => <PhonicsEncodeEditor />,
  spellingToSound: () => <PhonicsDecodeEditor />,
  handWriting: () => <HandWritingEditor />,
};

export function useGetCanvas() {
  const { slide } = useAppSelector((state) => state.slideEditor.present);
  const template = resolveSlideTemplate(slide);

  if (!template) return <CanvasSkeleton label="Not Found" />;
  return EDITOR_BY_TEMPLATE[template]();
}
